
require('../bootstrap');

import {createApp, h} from 'vue'
import routes from "./router/routes-login";
import './assets/scss/config/default/app.scss'
import {asset} from "@codinglabs/laravel-asset";
import login from "./views/account/login";

const mixin = {
    methods: {
        asset: asset,
        castTimestamps(obj) {
            let date = new Date(obj.created_at);
            obj.created_at = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.toLocaleTimeString()}`;

            date = new Date(obj.updated_at);
            obj.updated_at = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.toLocaleTimeString()}`;
        }
    }
}

const el = document.getElementById('app');
const app = createApp(
    {
        render: () => h(login),
    })
    .use(routes)

app.mount(el)
